var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89668 34.6553C6.82814 34.6544 6.76009 34.667 6.69648 34.6926C6.63288 34.7181 6.57499 34.7561 6.52618 34.8042C6.47737 34.8523 6.43861 34.9097 6.41215 34.9729C6.38569 35.0362 6.37207 35.104 6.37207 35.1726C6.37207 35.2411 6.38569 35.309 6.41215 35.3722C6.43861 35.4355 6.47737 35.4928 6.52618 35.5409C6.57499 35.5891 6.63288 35.627 6.69648 35.6526C6.76009 35.6781 6.82814 35.6908 6.89668 35.6898H15.8622C15.9307 35.6908 15.9988 35.6781 16.0624 35.6526C16.126 35.627 16.1839 35.5891 16.2327 35.5409C16.2815 35.4928 16.3203 35.4355 16.3467 35.3722C16.3732 35.309 16.3868 35.2411 16.3868 35.1726C16.3868 35.104 16.3732 35.0362 16.3467 34.9729C16.3203 34.9097 16.2815 34.8523 16.2327 34.8042C16.1839 34.7561 16.126 34.7181 16.0624 34.6926C15.9988 34.667 15.9307 34.6544 15.8622 34.6553H6.89668Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67125 0.172363C1.74493 0.172363 0.172363 1.74493 0.172363 3.67125V35.5306C0.172363 37.4569 1.74493 39.0295 3.67125 39.0295H19.6016C21.528 39.0295 23.1005 37.4569 23.1005 35.5306V3.67125C23.1005 1.74494 21.528 0.172363 19.6016 0.172363H3.67125ZM3.67125 1.19643H19.6016C20.9745 1.19643 22.0764 2.29837 22.0764 3.67125V35.5306C22.0764 36.9035 20.9745 38.0054 19.6016 38.0054H3.67125C2.29838 38.0054 1.19643 36.9035 1.19643 35.5306V3.67125C1.19643 2.29838 2.29838 1.19643 3.67125 1.19643Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.4483,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.bd7f162bed5af07196590cb6687d0f29.svg";
export { ForwardRef as ReactComponent };